<script lang="ts">
import draggable from 'vuedraggable';
export default draggable;
</script>